import { IApiGetLpAdapterSchemaRes, IApiLpAdapter } from '@cbridge-packages/api-admin';
import { ILpAdapter, ILpAdapterSchemas, LpIntegrationDirection } from './lpAdapters.interface';

// The client by-name response also carries the direction; the admin one does not.
type IApiAdapterSchemasRes = IApiGetLpAdapterSchemaRes & { integrationDirection?: string };

export namespace LpAdaptersTranslator {
  // CP omits the direction on older builds and for outbound adapters alike.
  export function fromApiIntegrationDirection(direction?: string): LpIntegrationDirection {
    return direction === LpIntegrationDirection.Inbound ? LpIntegrationDirection.Inbound : LpIntegrationDirection.Outbound;
  }

  export function fromApiAdapter(adapter: IApiLpAdapter): ILpAdapter {
    return {
      name: adapter.name,
      integrationDirection: fromApiIntegrationDirection(adapter.integrationDirection),
    };
  }

  // Split shape: `pricing` is mandatory and a missing `trading` means the adapter has
  // no trading connection. Legacy shape: one schema applied to both connections.
  export function fromApiSchemas(res: IApiAdapterSchemasRes): ILpAdapterSchemas | undefined {
    const direction = res.integrationDirection === undefined
      ? {}
      : { integrationDirection: fromApiIntegrationDirection(res.integrationDirection) };

    if (res.pricing) {
      return { pricing: res.pricing, trading: res.trading ?? null, ...direction };
    }

    return res.schema
      ? { pricing: res.schema, trading: res.schema, ...direction }
      : undefined;
  }
}
